import { action } from 'mobx';
import moment from 'moment';
import { Contact, Entity, Scenario } from '../..';
import { ISerializable } from '../../Entity';

export default class ContactScenario extends Entity implements ISerializable {

    constructor(contactScenario?: Partial<ContactScenario>) {
        super(contactScenario);
        if (contactScenario) this.update(contactScenario);
    }

    createdDate: moment.Moment;
    completedDate?: moment.Moment;
    scenario: Scenario;
    student: Contact;

    toJson() {
        return {
            id: this.id,
            completedDate: this.completedDate,
            scenarioId: this.scenario?.id,
            studentId: this.student?.id
        };
    }

    clone(changes?: Partial<ContactScenario>) {
        return new ContactScenario({
            ...this,
            node: this.scenario?.clone(),
            student: this.student?.clone(),
            ...changes
        });
    }

    @action update(contactScenario: Partial<ContactScenario>, allowUndefined = false) {
        super.update(contactScenario, allowUndefined);
    }

    static fromJson(json: any): ContactScenario {
        return new ContactScenario({
            ...json,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined,
            completedDate: json.completedDate ? moment(json.completedDate) : undefined,
            scenario: json.scenario ? Scenario.fromJson(json.scenario) : undefined,
            student: json.student ? Contact.fromJson(json.student) : undefined
        });
    }
}